import getEwsRequestDateString from 'owa-mail-store/lib/services/utils/getEwsRequestDateString';
import getServiceContextFolderId from 'owa-mail-store/lib/services/utils/getServiceContextFolderId';
import applyConversationActionRequest from 'owa-service/lib/factory/applyConversationActionRequest';
import conversationAction from 'owa-service/lib/factory/conversationAction';
import itemId from 'owa-service/lib/factory/itemId';
import applyConversationActionOperation from 'owa-service/lib/operation/applyConversationActionOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Create a ConversationAction with delete params for a given conversation.
 * @param conversationContext the conversation context to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType  the disposal type
 * @returns a ConversationAction
 */
function createDeleteConversationAction(conversationContext, contextFolderId, disposalType) {
    return conversationAction({
        Action: 'Delete',
        ConversationId: itemId({ Id: conversationContext.conversationId }),
        DeleteType: disposalType,
        ConversationLastSyncTime: getEwsRequestDateString(conversationContext.conversationLastSyncTimeStamp),
        SuppressReadReceipts: true,
        ContextFolderId: getServiceContextFolderId(contextFolderId),
    });
}
/**
 * Worker method which converts the provided data into a delete ApplyConversationActionRequest.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 * @returns an ApplyConversationActionRequest
 */
function configureRequestBody(conversationContexts, contextFolderId, disposalType) {
    var conversationActions = conversationContexts.map(function (conversationContext) {
        return createDeleteConversationAction(conversationContext, contextFolderId, disposalType);
    });
    return applyConversationActionRequest({
        ConversationActions: conversationActions,
        ReturnMovedItemIds: false,
    });
}
/**
 * The service which calls the ApplyConversationAction with delete parameters.
 * @param conversationContexts the conversation contexts to be deleted
 * @param contextFolderId  the folder where the conversations will be deleted from
 * @param disposalType the disposal type
 */
export default function deleteConversationService(conversationContexts, contextFolderId, disposalType, options) {
    var requestBody = configureRequestBody(conversationContexts, contextFolderId, disposalType);
    // Work Item 27629: Remove workaround for timezone issue (sending requests in UTC time zone)
    var jsonRequestHeader = getJsonRequestHeader();
    jsonRequestHeader.TimeZoneContext.TimeZoneDefinition.Id = 'UTC';
    return applyConversationActionOperation({
        Header: jsonRequestHeader,
        Body: requestBody,
    }, options).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
//# sourceMappingURL=deleteConversationService.js.map